/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Clickup_W3Inputs */

const en_mk_cmp_clickup_w3 = /** @type {(inputs: Mk_Cmp_Clickup_W3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrating with dozens of other tools matters more to you than a predictable AI bill.`)
};

const id_mk_cmp_clickup_w3 = /** @type {(inputs: Mk_Cmp_Clickup_W3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrasi ke puluhan alat lain lebih penting daripada biaya AI yang terprediksi.`)
};

/**
* | output |
* | --- |
* | "Integrating with dozens of other tools matters more to you than a predictable AI bill." |
*
* @param {Mk_Cmp_Clickup_W3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_clickup_w3 = /** @type {((inputs?: Mk_Cmp_Clickup_W3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Clickup_W3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_clickup_w3(inputs)
	return en_mk_cmp_clickup_w3(inputs)
});